function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/dom-helpers/~/@babel/runtime/helpers/interopRequireDefault.js
 ** module id = 25
 ** module chunks = 0
 **/